import { ApiError } from '../errors/api-error.js';

export class IntegrationExportApi {
    constructor(client) {
        this.client = client;
        this.basePath = '/integration';
    }
    async types() {
        try { return (await this.client.get(`${this.basePath}/exports/types`)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async create(input, idempotencyKey) {
        try {
            return (await this.client.post(`${this.basePath}/exports`, input, {
                headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
            })).data;
        } catch (e) { throw ApiError.fromResponse(e); }
    }
    async list(params = {}) {
        try { return (await this.client.get(`${this.basePath}/exports`, { params })).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async transfers(params = {}) {
        try { return (await this.client.get(`${this.basePath}/transfers`, { params })).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async get(id) {
        try { return (await this.client.get(`${this.basePath}/exports/${encodeURIComponent(String(id))}`)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async cancel(id) {
        try { return (await this.client.post(`${this.basePath}/exports/${encodeURIComponent(String(id))}/cancel`)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async download(id) {
        try {
            const response = await this.client.get(`${this.basePath}/exports/${encodeURIComponent(String(id))}/download`, { responseType: 'arraybuffer' });
            return { data: response.data, metadata: { contentType: response.headers?.['content-type'], contentDisposition: response.headers?.['content-disposition'] } };
        } catch (e) { throw ApiError.fromResponse(e); }
    }
    async exportEntity(type, format = 'json', idempotencyKey) {
        try {
            return (await this.client.get(`${this.basePath}/export/${encodeURIComponent(String(type))}`, {
                params: { format }, headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
            })).data;
        } catch (e) { throw ApiError.fromResponse(e); }
    }
}
